import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("RecentProjectsLinkWidget", {
  title: "Recent Project Link",
  propertiesGroups: [
    {
      title: "General",
      properties: [
        "title",
        "link",
        "description",
        "withIcon",
        "withProjectCountDescription",
        "widgetType",
      ],
    },
  ],
  initialContent: {
    iconName: "check-regular",
    title: "Title",
    withIcon: true,
    withProjectCountDescription: false,
    description: ["description", "description"],
  },
  validations: [
    [
      "title",
      (title) => {
        if (!title) {
          return {
            message: "title might be provided",
            severity: "warning",
          };
        }
      },
    ],
    [
      "link",
      (link) => {
        if (!link) {
          return {
            message: "Link should be provided",
            severity: "error",
          };
        }
      },
    ],
  ],
});
